<template>
  <div
    class="modal fade"
    ref="modal"
    tabindex="-1"
    aria-labelledby="preLabBlockersModalLabel"
    aria-hidden="true"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="preLabBlockersModalLabel">
            <i
              class="bi bi-exclamation-triangle-fill text-warning me-2"
              aria-hidden="true"
            ></i>
            Complete All Requirements
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body text-start">
          <p class="mb-2">Please address the following before proceeding:</p>
          <ul class="mb-0">
            <li v-for="(msg, i) in blockers" :key="i">{{ msg }}</li>
          </ul>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
            Got it
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {
  name: "PreLabBlockersModal",
  props: {
    blockers: {
      type: Array,
      required: true
    }
  },
  methods: {
    show() {
      Modal.getOrCreateInstance(this.$refs.modal).show();
    }
  }
};
</script>
